import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 5+ App Webview 返回键：壳子 evalJS 会调用，用于识别「已在首页」从而走双击退出（history.length 在 SPA 里不可靠）
if (typeof window !== 'undefined') {
  window.__KHGL_ROUTER = router
  window.__appAtHome = function () {
    try {
      const p = (router.currentRoute && router.currentRoute.path) || ''
      return p === '/home' || p === '/'
    } catch (e) {
      return false
    }
  }
}
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAMap from 'vue-amap'
import axios from 'axios'

Vue.use(ElementUI)
Vue.use(VueAMap)
// 初始化高德地图
VueAMap.initAMapApiLoader({
  key: '26eadff5b40291efb2631f1c7bb5e21a', // 高德地图API密钥
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geocoder'
  ],
  v: '1.4.15',
  autoload: true // 自动加载API
})

// 注册axios为全局属性
Vue.prototype.$axios = axios

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')